import React from 'react';
import sIcon1 from '../../images/icon/eye-icon.svg'
import sIcon2 from '../../images/feature/1.png'
import sIcon3 from '../../images/feature/image.png'
import sIcon4 from '../../images/feature/3m.png'

const WhyChoose = (props) => {

    return (
        <section className="feature pt-130">
            <div className="container">
                <div className="sec-title--two text-center mb-60">
                    <div className="sub-title"><img src={sIcon1} alt=""/> Why choose us</div>

                    {/* CHANGED */}
                    <h2 className="title">Customer-Centric Solutions</h2>
                </div>

                <div className="row mt-none-30">

                    <div className="col-lg-4 col-md-6 mt-30">
                        <div className="ap-fea-item pos-rel">
                            <div className="xb-item--img"><img src={sIcon2} alt=""/></div>

                            {/* CHANGED – same length style */}
                            <h3 className="xb-item--content">We deliver solid Odoo ERP results</h3>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 mt-30">
                        <div className="ap-fea-item pos-rel">
                            <div className="xb-item--img"><img src={sIcon3} alt=""/></div>

                            {/* CHANGED – same length style */}
                            <h3 className="xb-item--content">If issues arise, our team fixes fast</h3>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 mt-30">
                        <div className="ap-fea-item pos-rel">
                            <div className="xb-item--img"><img src={sIcon4} alt=""/></div>

                            {/* CHANGED – same length style */}
                            <h3 className="xb-item--content">We build custom ERP & eCommerce tools</h3>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default WhyChoose;
